var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"section"}},[_c('div',{staticClass:"bottom"}),_c('Home'),_c('Index'),_c('Back'),_c('Foot')],1)}
var staticRenderFns = []

export { render, staticRenderFns }